var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _vm.eligibilityInfo.testChips == null
        ? _c("ob1-message-alerte", {
            attrs: {
              "data-testid": "eligibility-info-alert",
              "is-simple-alerte":
                _vm.eligibilityInfo.eligibilityMessage.simpleAlert,
              type: _vm.formattedType,
              title: _vm.eligibilityInfo.eligibilityMessage.title,
              texts: _vm.eligibilityInfo.eligibilityMessage.texts,
              "with-arrow-link": _vm.withArrowLink,
              "link-href": _vm.linkHref,
              target: _vm.linkTarget,
              "data-bs-toggle": _vm.linkDataToggle,
              "link-label": _vm.linkText,
              "with-button-from-dto": _vm.buttonFromDto,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfo.testChips
        ? _c(
            "div",
            { staticClass: "d-flex flex-wrap align-items-center pb-2 ps-1" },
            [
              _c("div", { staticClass: "pe-1" }, [
                _c(
                  "span",
                  { staticClass: "ob1-capsule ob1-capsule-reminder" },
                  [
                    _c("span", {
                      attrs: { "data-cs-mask": "" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.eligibilityInfo.testChips.reminder
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "icon icon-map-pin",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("button", {
                  staticClass: "ob1-link-arrow",
                  attrs: {
                    type: "submit",
                    form: "tester-eligibilite",
                    name: "position",
                    value: _vm.eligibilityInfo.testChips.modifyLabel,
                    "data-oevent-category":
                      _vm.eligibilityInfo.testChips.tag.category,
                    "data-oevent-action":
                      _vm.eligibilityInfo.testChips.tag.action,
                    "data-oevent-label":
                      _vm.eligibilityInfo.testChips.tag.label,
                  },
                  domProps: {
                    textContent: _vm._s(
                      _vm.eligibilityInfo.testChips.modifyLabel
                    ),
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfo.fiberPopin
        ? _c(
            "section",
            [
              _c(
                "ob1-popin-modal",
                {
                  attrs: {
                    "data-testid": "eligibility-info-fiber-popin",
                    "popin-modal-dto":
                      _vm.eligibilityInfo.fiberPopin.popinModal,
                  },
                },
                [
                  _c("FiberPopin", {
                    attrs: { dto: _vm.eligibilityInfo.fiberPopin },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfo.pifInfos
        ? _c(
            "section",
            [
              _c("PifInfos", {
                attrs: {
                  "data-testid": "eligibility-info-pif",
                  "pif-infos": _vm.eligibilityInfo.pifInfos,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eligibilityInfo.pifXgsponInfos
        ? _c(
            "section",
            [
              _c("PifXgsponInfos", {
                attrs: {
                  "data-testid": "eligibility-info-pif-xgspon",
                  "pif-xgspon-infos": _vm.eligibilityInfo.pifXgsponInfos,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }